import * as React from "react"
import styled from "styled-components"
import ProfileImage from "../atoms/ProfileImage"
import BodyMedium from "../atoms/typography/BodyMedium"
import Body from "../atoms/typography/Body"
import { HorizontalSpacer } from "../atoms/spacers"

interface Props {
  imgSrc: string
  name: string
  role: string
  title?: string
}

const CardContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 0.5rem;
`

const MemberProfileOverview: React.FunctionComponent<Props> = ({ imgSrc, name, role, title }) => {
  return (
    <CardContainer>
      <ProfileImage src={imgSrc} alt={`Profile image ${name}`} />
      <div>
        <BodyMedium>{name}</BodyMedium>
        <HorizontalSpacer spacing={0.5} />
        <Body>
          {role} {title && `/ ${title}`}
        </Body>
      </div>
    </CardContainer>
  )
}

export default MemberProfileOverview
